<!-- todo 仅用于数字控件 0 返回空 &千分位格式化，目前仅用于显示 临时使用 （财务审核 基本页签查看）-->
<template>
  <div style="display: flex;line-height: 28px">
    <!--    <el-input-->
    <!--      v-model="inputValue"-->
    <!--      type="number"-->
    <!--      :disabled="Boolean(checkboxValue.length)"-->
    <!--      onkeyup="this.value=this.value.match(/^\d*(\.?\d{0,9})/g)"-->
    <!--      style="width: 100px"-->
    <!--      @change="handleInput"-->
    <!--    />-->
    <num-input
      v-model="inputValue"
      :precision="this.precision"
      :disabled="Boolean(checkboxValue.length)"
      style="width: 100px"
      :round="true"
      @change="handleInput"
    />
    <el-checkbox-group
      v-model="checkboxValue"
      :max="1"
      @change="handleChange"
    >
      <el-checkbox v-if="showTact" label="TACT" style="padding-left: 2px; width: 30px;" />
      <el-checkbox label="NIL" style="padding-left: 2px; width: 30px;" />
    </el-checkbox-group>
  </div>
</template>

<script>
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import NumInput from '@/components/Cargo/Common/NumInput'

export default {
  name: 'PriceAirNumericStepper',
  components: {
    NumInput
  },
  model: {
    prop: 'value', event: 'change'
  },
  props: {
    precision: { type: Number, default: 2 }, // 默认截取小数位数 2
    showTact: { type: Boolean, default: false },
    value: { type: [Number, String], default: () => null }
  },
  data() {
    return {
      inputValue: null,
      checkboxValue: []
    }
  },
  watch: {

  },
  created() {
    const { value } = this
    if (value) {
      this.inputValue = null
      this.checkboxValue = []
      if (value === PriceConstant.NIL) {
        this.checkboxValue = ['NIL']
      } else if (value === PriceConstant.TACT) {
        this.checkboxValue = ['TACT']
      } else {
        this.inputValue = this.getValue(value)
      }
    }
  },
  methods: {
    handleInput(e) {
      console.log('price', e)
      const val = this.getValue(e)
      this.$emit('change', val)
      this.inputValue = val
    },
    handleChange(e) {
      console.log('price', e)
      this.inputValue = null
      if (e.length) {
        this.$emit('change', PriceConstant[e[0]])
      } else {
        this.$emit('change', null)
      }
    },
    getValue(val) {
      let formatter = '0.'
      for (let i = 0; i < this.precision; i++) {
        formatter += '0'
      }
      return this.$numeral(val).format(formatter)
    }
  }
}
</script>

<style scoped>
#app .cargo-number-input >>> input{
  text-align:right;
}
</style>
